// extracted by mini-css-extract-plugin
export default {"main":"_6a7b9176c0 _7e9a5c767e","xmark":"dda2a04541","fl_img":"_854c9a9839 _3f9318600f"};